import { createFileRoute } from '@tanstack/react-router'
import { AppBootScreen } from '@/components/layout/AppBootScreen'
import { DeferredNotFound } from '@/components/layout/deferredRouteChrome'
import { bootstrapAuth } from '@/lib/apiClient'

/**
 * Catch-all route ($ / splat) rendering the brand-aligned 404 Page Not Found component.
 */
export const Route = createFileRoute('/$')({
  pendingComponent: AppBootScreen,
  pendingMs: 0,
  pendingMinMs: 0,
  beforeLoad: async () => {
    // Silently refresh auth token if a session exists
    await bootstrapAuth()
  },
  component: DeferredNotFound,
})
